import { Route, Routes } from "react-router-dom";
import DisplayBooks from "../pages/Books/DisplayBooks";
import AddEditBooks from "../pages/Books/AddEditBooks";
import Sidebar from "../components/MainSidebar";
import DisplayAuthors from "../pages/Authors/DisplayAuthors";
import AddEditAuthors from "../pages/Authors/AddEditAuthors";
import DisplayFaqs from "../pages/Faqs/DisplayFaqs";
import AddEditFaqs from "../pages/Faqs/AddEditFaqs";
import DisplayBlogs from "../pages/Blogs/DisplayBlogs";
import AddEditBlogs from "../pages/Blogs/AddEditBlogs";
import AddEditLanguages from "../pages/Languages/AddEditLanguages";
import DisplayLanguages from "../pages/Languages/DisplayLanguages";
import DisplayTestimonials from "../pages/Testimonials/DisplayTestimonials";
import AddEditTestimonials from "../pages/Testimonials/AddEditTestimonials";
import DisplayEnqiury from "../pages/Enquiries/DisplayEnquiry";
import AddEditEnquiry from "../pages/Enquiries/AddEditEnquiry";
import DisplayCategory from "../pages/Categories/DisplayCategory";
import AddEditCategory from "../pages/Categories/AddEditCategory";
import DisplaySubCategory from "../pages/SubCategories/DisplaySubCategory";
import AddEditSubCategory from "../pages/SubCategories/AddEditSubCategory";
import DisplayBookings from "../pages/Bookings/DisplayBookings";
import BookingDetails from "../pages/Bookings/BookingDetails";
import Dashboard from "../pages/Dashboard/Dashboard";
import DisplayCombos from "../pages/Books/DisplayCombos";
import AddEditCombos from "../pages/Books/AddEditCombos";
import NewRelease from "../pages/Books/NewRelease";
import Login from "../components/Login";
import RevenuDetails from "../pages/Dashboard/RevenuDetails";
import DisplayUsers from "../pages/Users/DisplayUsers";
import ViewUserDetails from "../pages/Users/ViewUserDetails";

const PageRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<Dashboard />} />

                <Route path="/display-books" element={<DisplayBooks />} />
                <Route path="/create-edit-books" element={<AddEditBooks />} />
                <Route path="/display-combos" element={<DisplayCombos />} />
                <Route path="/create-edit-combos" element={<AddEditCombos />} />
                <Route path="/new-release" element={<NewRelease />} />

                <Route path="/display-authors" element={<DisplayAuthors />} />
                <Route path="/create-edit-authors" element={<AddEditAuthors />} />

                <Route path="/display-blogs" element={<DisplayBlogs />} />
                <Route path="/create-edit-blogs" element={<AddEditBlogs />} />

                <Route path="/display-languages" element={<DisplayLanguages />} />
                <Route path="/create-edit-languages" element={<AddEditLanguages />} />

                <Route path="/display-faqs" element={<DisplayFaqs />} />
                <Route path="/create-edit-faqs" element={<AddEditFaqs />} />

                <Route path="/display-testimonials" element={<DisplayTestimonials />} />
                <Route path="/create-edit-testimonials" element={<AddEditTestimonials />} />

                <Route path="/display-enquiry" element={<DisplayEnqiury />} />
                {/* <Route path="/create-edit-enquiry" element={<AddEditEnquiry />} /> */}

                <Route path="/display-category" element={<DisplayCategory />} />
                <Route path="/create-edit-category" element={<AddEditCategory />} />

                <Route path="/display-subcategory" element={<DisplaySubCategory />} />
                <Route path="/create-edit-subcategory" element={<AddEditSubCategory />} />

                <Route path="/display-bookings" element={<DisplayBookings />} />
                <Route path="/booking-details/:bookingId" element={<BookingDetails />} />


                <Route path="/revenuedetails" element={<RevenuDetails />} />
                <Route path="/users" element={<DisplayUsers />} />
                 <Route path="/user-details" element={<ViewUserDetails />} />


            </Routes>
        </>
    )
}

export default PageRoutes;